var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from 'fbm-ui';
import { theme } from 'fbm-ui/lib/components';
var Nps = function (_a) {
    var formAnswer = _a.formAnswer, formItemOption = _a.formItemOption;
    var answer = (formAnswer || {
        answer: '',
    }).answer;
    var from = formItemOption.from, to = formItemOption.to;
    var fromScore = (from === null || from === void 0 ? void 0 : from.score) || 0;
    var toScore = (to === null || to === void 0 ? void 0 : to.score) || 0;
    var npsData = __spreadArray([], __read(Array.from(new Array(toScore + 1 - fromScore).keys())), false).map(function (i) { return i + fromScore; });
    if (!answer)
        return null;
    return (_jsxs(Box, { children: [_jsx(Box, __assign({ display: "flex" }, { children: typeof answer === 'string' &&
                    npsData.map(function (value) {
                        var isSelect = value <= Number(answer);
                        return (_jsx(Box, __assign({ height: 30, flex: "1 0", lineHeight: "30px", textAlign: "center", margin: "0 2px", fontSize: 14, fontWeight: 500, color: isSelect ? '#fff' : '', bgcolor: isSelect ? theme.palette.primary.main : '#eceff1' }, { children: value }), value));
                    }) })), _jsxs(Box, __assign({ display: "flex", justifyContent: "space-between", mt: 1 }, { children: [_jsx(Typography, __assign({ variant: "body2", color: "secondary" }, { children: from === null || from === void 0 ? void 0 : from.remark })), _jsx(Typography, __assign({ variant: "body2", color: "secondary" }, { children: to === null || to === void 0 ? void 0 : to.remark }))] }))] }));
};
export default Nps;
